import { render, staticRenderFns } from "./mazda-50-50-content.vue?vue&type=template&id=b2939932&scoped=true&"
var script = {}
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=b2939932&scoped=true&lang=css&"
import style1 from "./mazda-50-50-content.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2939932",
  null
  
)

export default component.exports